import { validateReferralField } from '@components/ReferralField/validate';
import { ValidationErrorMessages } from '@constants/forms';
import { PartnerFormValues } from '@features/Partner/types';

interface FormErrors {
  appointmentType?: string;
  introducedBy?: string;
  customerReferral?: string;
  connectorReferral?: string;
}

const validate = (values: PartnerFormValues) => {
  let errors: FormErrors = {};

  if (!values.appointmentType) {
    errors.appointmentType = ValidationErrorMessages.FIELD_REQUIRED;
  }

  const referrerFieldErrors = validateReferralField(values);

  errors = { ...errors, ...referrerFieldErrors };

  return Object.keys(errors).length > 0 ? errors : {};
};

export { validate };
